import React from 'react'

import { StyledTitleType } from '@contracts/Components/StyledTitle'

import * as styles from './StyledTitle.module.scss'

interface Props {
	data: StyledTitleType
	tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
	className?: string
	titleClassName?: string
}

const StyledTitle = (props: Props) => {
	const Tag = `${props.tag}`
	const titles = props.data

	const classNames = [styles.titles]
	const titleClasses = [styles.title]

	if (props.className) {
		classNames.push(props.className)
	}

	if (props.titleClassName) {
		titleClasses.push(props.titleClassName)
	}

	if (titles && typeof titles === 'object') {
		return (
			<Tag className={classNames.join(' ')}>
				{titles.map(({ styledText }, i) => {
					let title = styledText.text
					const localTitleClasses = [...titleClasses]

					if (styledText.isYellow) {
						localTitleClasses.push(styles.yellow)
					}

					if (styledText.isThin) {
						localTitleClasses.push(styles.thin)
					}

					if (styledText.isSplit) {
						localTitleClasses.push(styles.split)

						// Split title on spaces and wrap each word in a span, then join
						title = title
							.split(' ')
							.map((word) => {
								return `<span>${word}</span>`
							})
							.join(' ')
					}

					return (
						<div
							key={`title-${i}`}
							dangerouslySetInnerHTML={{ __html: title }}
							className={localTitleClasses.join(' ')}
						></div>
					)
				})}
			</Tag>
		)
	}

	return null

	return <div dangerouslySetInnerHTML={{ __html: title }} className={classNames.join(' ')}></div>
}

export default StyledTitle
